export default {"src":"/_next/static/media/settings.3c291784.svg","height":16,"width":4,"blurWidth":0,"blurHeight":0};